import { isValid } from 'date-fns';
import { fromZonedTime } from 'date-fns-tz';

/** The picker's local date fields represent wall-clock time in the selected zone. */
export function pickerDateToUtc(date: Date | null, timezone: string): string | null {
  if (!date || !isValid(date)) return null;
  const utcDate = fromZonedTime(date, timezone);
  return isValid(utcDate) ? utcDate.toISOString() : null;
}

export function isFutureSchedule(scheduledAt: string, now = Date.now()): boolean {
  return new Date(scheduledAt).getTime() > now;
}
